module.exports = __webpack_public_path__ + "static/media/HWd9PhvU.60f14435.jpeg";